import React, { useEffect, useState } from 'react';
import { Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { useForm } from 'react-hook-form';
import { currencyArray } from 'store/constant';
import { ToastContainer, toast } from 'react-toastify';
import axiosInstance from 'custom-axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownload from '@mui/icons-material/CloudDownload';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';


const contentTypes = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png'
};

const BankInformation = ({ formAccountData, userId, setFormAccountData, activeAccountStep, setActiveAccountStep, accountTypeId }) => {
    const [bankDetails, setBankDetails] = useState([...formAccountData.bank_information]);
    // const [accountTypeId, setAccountTypeId] = useState(1)
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        mode: 'submitClientForm',
        // resolver: yupResolver(householdValidation),
        // defaultValues: {
        // 	selectedOptions: formAccountData.selectedOptions || []
        // }
    });

    const getFileExtension = (fileName) => {
        return fileName.split('.').pop().toLowerCase();
    };

    const fetchBankData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-bank-info/${userId}`);


            if (response.data.length > 0) {
                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    bank_information: response.data
                }));
                setBankDetails(response.data);
            }


        } catch (error) {
            console.error(error.message);
        }
    }



    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                }));
            }
        } catch (error) {
            console.error(error.message);
        }
    }



    const handleChange = (e, index) => {
        const { name, value } = e.target;
        const updatedPolicies = [...bankDetails];
        updatedPolicies[index][name] = value;
        setBankDetails(updatedPolicies);

        setFormAccountData(prevData => ({
            ...prevData,
            bank_information: updatedPolicies
        }));
    };

    const addNewTemplate = () => {
        const newObject = {
            bank_name: '',
            bank_currency: '',
            bank_transit_number: '',
            bank_institution_number: '',
            bank_account_number: '',
        };
        setBankDetails([...bankDetails, newObject]);
    };

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        // const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep - 1 }

        let modifiedChildStep = activeAccountStep - 1

        if (formAccountData.account_transfer == 2) {
            modifiedChildStep = activeAccountStep - 2
        }

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const removeBankDetails = async (index, bankDetailsId) => {

        if (bankDetailsId) {

            const result = await showConfirmSweetAlert({
                title: 'Are you sure?',
                text: `You will not be able to recover this!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                showLoader()
                try {
                    const response = await axiosInstance.delete(`api/delete-bank-information/${bankDetailsId}`);

                    hideLoader()

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error(response.message);
                    }

                } catch (error) {
                    toast.error(error.message);
                }
            }

        } else {
            const updatedTransferDetails = [...bankDetails];
            updatedTransferDetails.splice(index, 1);
            setBankDetails(updatedTransferDetails);
        }
    }

    const hasEmptyValues = (bankDetails) => {
        const requiredFields = [
            "bank_name",
            "bank_transit_number",
            "bank_account_number",
            "bank_currency",
            "bank_institution_number"
        ];

        return bankDetails?.some(bank =>
            requiredFields.some(field => bank[field] === null || bank[field] === "")
        );
    };

    const submitForm = async () => {

        if (hasEmptyValues(bankDetails)) {
            toast.error('Please fill in all bank details.');
            return;
        }

        setFormAccountData(prevData => ({
            ...prevData,
            bank_information: bankDetails
        }));



        let endPoint = `api/save-user-bank-info`;

        // const submitData = { add_bank_details: bankDetails, accountTypeId: accountTypeId, user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep + 1 }


        let modifiedChildStep = activeAccountStep + 1;

        // If both account_eft and account_pac are 2, skip both steps accordingly
        if (formAccountData.account_eft == 2 && formAccountData.account_pac == 2 && formAccountData.account_swp == 2 && formAccountData.account_income_sweep == 2) {
            modifiedChildStep = 7;

        } else {

            const stepsToCheck = [
                { stepIndex: 4, value: formAccountData.account_eft },
                { stepIndex: 5, value: formAccountData.account_pac },
                { stepIndex: 6, value: formAccountData.account_swp },
                { stepIndex: 7, value: formAccountData.account_income_sweep },
            ];

            // Find the highest-priority step where the value is 1
            for (const step of stepsToCheck) {
                if (step.value === 1) {
                    modifiedChildStep = step.stepIndex;
                    break;
                }
            }
        }


        // todo:: remove  this format and submit normal formData
        const formData = new FormData();

        formData.append('accountTypeId', accountTypeId);
        formData.append('user_id', userId || 0);
        formData.append('parent_step', 1);
        formData.append('child_step', modifiedChildStep);
        formData.append('login_id', formAccountData.login_id || 0);

        bankDetails.forEach((bankDetail, index) => {
            formData.append(`add_bank_details[${index}][id]`, bankDetail.id || '');
            formData.append(`add_bank_details[${index}][user_id]`, bankDetail.user_id || '');
            formData.append(`add_bank_details[${index}][account_type_id]`, bankDetail.account_type_id || '');
            formData.append(`add_bank_details[${index}][bank_name]`, bankDetail.bank_name || '');
            formData.append(`add_bank_details[${index}][bank_transit_number]`, bankDetail.bank_transit_number || '');
            formData.append(`add_bank_details[${index}][bank_account_number]`, bankDetail.bank_account_number || '');
            formData.append(`add_bank_details[${index}][bank_currency]`, bankDetail.bank_currency || '');
            formData.append(`add_bank_details[${index}][bank_institution_number]`, bankDetail.bank_institution_number || '');

        });


        try {
            // const response = await axiosInstance.post(endPoint, formData);
            const response = await axiosInstance.post(endPoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            console.error(error)
        }
    }

    const fetchAllApi = async () => {
        try {
            showLoader()
            await fetchBankData()
            await fetchAccountTypeInfoData()
            hideLoader()

        } catch (error) {
            hideLoader()
        }
    }


    useEffect(() => {
        fetchAllApi()
    }, [])

    return (
        <>
            <form onSubmit={handleSubmit(submitForm)}>

                {bankDetails?.map((item, index) => {

                    return (
                        <div className='mt-3 padding-left35px padding-right35px' style={{ width: '100%' }}>

                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                className='form-head-gray-title'
                            >

                                <Grid item>
                                    <Typography component={'h3'}>Bank Information #{index + 1}</Typography>
                                </Grid>

                                <Grid item>
                                    <IconButton style={{ padding: '0px 10px 0px 0px' }} disabled={index == 0} onClick={() => removeBankDetails(index, item.id)}>
                                        <DeleteIcon sx={{ color: '#dd4747' }} />
                                    </IconButton>
                                </Grid>
                            </Grid>


                            <Grid container spacing={2} className='p-4'>
                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                    <label htmlFor="bank-name" className='font15px'>Name Of Bank</label>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        label="Name Of Bank"
                                        fullWidth
                                        size="small"
                                        name='bank_name'
                                        onChange={(e) => handleChange(e, index)}
                                        value={item.bank_name}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}></Grid>


                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                    <label htmlFor="bank-name" className='font15px'>Currency</label>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                    >
                                        <InputLabel id="select-tpi-instruction-currency">Currency</InputLabel>
                                        <Select
                                            labelId="select-tpi-instruction-currency"
                                            label="Currency"
                                            value={item.bank_currency}
                                            classes={{ select: "custom-select-label" }}
                                            name='bank_currency'
                                            MenuProps={{
                                                disableScrollLock: true,
                                                PaperProps: { sx: { maxHeight: 200 } }
                                            }}

                                            inputProps={{
                                                ...register('bank_currency', {
                                                    require: true,
                                                    onChange: (e) => handleChange(e, index),
                                                })
                                            }}
                                        // onChange={(e) => handleChange(e, index)}
                                        >
                                            {currencyArray.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}></Grid>


                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                    <label htmlFor="bank_transit_number" className='font15px'>Bank Transit Number</label>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        label="Bank Transit Number"
                                        fullWidth
                                        size="small"
                                        name='bank_transit_number'
                                        onChange={(e) => handleChange(e, index)}
                                        value={item.bank_transit_number}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}></Grid>


                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                    <label htmlFor="bank_institution_number" className='font15px'>Institution Number</label>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>

                                    <TextField
                                        label="Institution Number"
                                        fullWidth
                                        size="small"
                                        name='bank_institution_number'
                                        onChange={(e) => handleChange(e, index)}
                                        value={item.bank_institution_number}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}></Grid>


                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                    <label htmlFor="bank-account-number" className='font15px'>Bank Account Number</label>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        label="Bank Account Number"
                                        fullWidth
                                        size="small"
                                        name='bank_account_number'
                                        onChange={(e) => handleChange(e, index)}
                                        value={item.bank_account_number}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}></Grid>
                            </Grid>
                        </div>
                    )
                })}

                <Button startIcon={<AddIcon />} onClick={addNewTemplate}>
                    Add Bank Information
                </Button>

                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form>
            {loader}
            <ToastContainer />
        </>
    )
}

export default BankInformation